import React, { createContext, useContext, useEffect, useState } from 'react';

export const PopupContext = createContext();

export const CallProvider = ({ children }) => {
    const [isPopoverOpen, setPopoverOpen] = useState(false);
    const [agentname, setAgentname] = useState("");
    const [curDuaration, setCurDuaration] = useState("Connecting");
    const [isCallReady, setIsCallReady] = useState(false);
    const [toggleFun,setToggleFun] = useState(() => () => {});
    const [stopCall,setStopCall] = useState(() => () => {});
    const [transcript, setTranscript] = useState([]);
    const [showTranscript, setShowTranscript] = useState(true);
    const [showLoading , setShowLoading] = useState(true);
    const [voiceIcon , setVoiceicon] = useState({});
    return (
        <PopupContext.Provider value={{
            isPopoverOpen,
            setPopoverOpen,
            agentname,
            setAgentname,
            curDuaration,
            setCurDuaration,
            isCallReady,
            setIsCallReady,
            toggleFun,
            setToggleFun,
            stopCall,
            setStopCall,
            transcript,
            setTranscript,
            showTranscript,
            setShowTranscript,
            showLoading,
            setShowLoading,
            voiceIcon,
            setVoiceicon
        }}>
            {children}
        </PopupContext.Provider>
    );
};

export const useWebCallContext = () => useContext(PopupContext);
